import {
  canonicalOrganizations,
  canonicalRoles,
  canonicalSites,
  canonicalUsers,
  canonicalProviders,
  canonicalPatients,
  canonicalHealthcards,
  canonicalStatuses,
  canonicalPayors,
  canonicalTariffs,
  canonicalSubmissions,
  canonicalClaims,
} from './entities';
import {
  defaultClaim,
  defaultHealthcard,
  defaultOrganization,
  defaultPatient,
  defaultPayor,
  defaultProvider,
  defaultRole,
  defaultSite,
  defaultStatus,
  defaultSubmission,
  defaultTariff,
  defaultUser,
} from './entities';

export const factorySeeds = {
  organization: defaultOrganization,
  role: defaultRole,
  site: defaultSite,
  user: defaultUser,
  provider: defaultProvider,
  patient: defaultPatient,
  healthcard: defaultHealthcard,
  status: defaultStatus,
  payor: defaultPayor,
  tariff: defaultTariff,
  submission: defaultSubmission,
  debit: {
    ...defaultClaim.debits[0],
    claim: defaultClaim,
    claimID: defaultClaim.id,
    payor: defaultPayor,
    payorID: defaultPayor.id,
    provider: defaultProvider,
    providerID: defaultProvider.id,
    tariff: defaultTariff,
    tariffID: defaultTariff.id,
    eobs: [],
  },
  credit: {
    id: 'default-credit',
    siteID: defaultSite.id,
    providerID: defaultProvider.id,
    amount: '0',
    date: '2024-01-01T00:00:00.000Z',
    provider: defaultProvider,
    description: '',
    site: defaultSite,
    filename: '',
  },
  claim: defaultClaim,
  organizations: canonicalOrganizations,
  roles: canonicalRoles,
  sites: canonicalSites,
  users: canonicalUsers,
  providers: canonicalProviders,
  patients: canonicalPatients,
  healthcards: canonicalHealthcards,
  statuses: canonicalStatuses,
  payors: canonicalPayors,
  tariffs: canonicalTariffs,
  submissions: canonicalSubmissions,
  claims: canonicalClaims,
};
